import styled from 'styled-components'

export const Description = styled.div`
  margin-bottom: 16px;
`

export const ButtonContainer = styled.div`
  margin-bottom: 20px;
`

export const ClientSecretContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 20px;
`

export const ClientSecretContainerValue = styled.div`
  display: flex;
  align-items: center;
  font-family: var(--font-family-mono);
  gap: 8px;
`
